export default "__VITE_ASSET__ecfba862__"